<div *ngIf="reportType == 'InDetail-CreditOfficer'">
   
    <div class="container" id="print-section">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="4" style="font-size: small;">Vivek Saptahik</th>
                    <th colspan="5" style="font-size: small;">Advt. Credit Note Register</th>
                    <th colspan="5" style="font-size: small;">Date {{currentDate | date:'dd-MM-yyy'}}</th>
                </tr>
                <tr>
                    <th colspan="3" style="font-size: small;">InDetails - Officer</th>
                    <th colspan="7"></th>
                    <th colspan="4" style="font-size: small;">Date From  {{startDate | date:'dd-MM-yyy'}} To {{endDate | date :'dd-MM-yyy'}}</th>
                </tr>
                <tr>
                    <th style="font-weight: bold; font-size: 12px;">Credit Note No</th>
                    <th style="font-weight: bold; font-size: 12px;">CR Date</th>
                    <th style="font-weight: bold; font-size: 12px;">Advertiser<br>Name</th>
                    <th style="font-weight: bold; font-size: 12px;">Representative<br>Name</th>
                    <th style="font-weight: bold; font-size: 12px;">Office Rep<br>Name</th>
                    <th style="font-weight: bold; font-size: 12px;">Issue<br>Name</th>
                    <th style="font-weight: bold; font-size: 12px;">Issue<br>Date</th>
                    <th style="font-weight: bold; font-size: 12px;">Invoice<br>Number</th>
                    <th style="font-weight: bold; font-size: 12px;">Invoice<br>Date</th>
                    <th style="font-weight: bold; font-size: 12px;">Invoice<br>Net Amount</th>
                    <th colspan="2">Credit <br> Note Amount</th>
                    <th>Total <br> Credit<br>Amount</th>
                    <th style="font-weight: bold; font-size: 12px;">Remark</th>
                </tr>
                <tr>
                    <th colspan="10"></th>
                    <th style="text-align: center;">TDS</th>
                    <th style="text-align: center;">Other</th>
                    <th></th>
                </tr>  
                    

            </thead>

            <tbody *ngFor="let data of CreditadvtOffInDFormBenas; let i = index">
                <!-- Office Representative Header -->
                <tr>
                    <td style="font-weight: bold; font-size: 15px; background-color: #f8f9fa;" colspan="13">
                        Office Representative: {{data.off_rep_name}}
                    </td>
                </tr>
                
                <!-- Loop through grouped representatives -->
                <ng-container *ngFor="let rep of data.grouped_rep_data; let j = index">
                    <!-- Representative Header -->
                    <tr style="background-color: #e3f2fd;">
                        <td style="font-weight: bold; font-size: 14px;" colspan="13">
                            Representative: {{rep.rep_name}}
                        </td>
                    </tr>
                    
                    <!-- Representative Data Rows -->
                    <tr *ngFor="let item of rep.items">
                        <td style="font-size: 15px;">{{item.credit_voc_no}}</td>
                        <td style="font-size: 15px;">{{item.voc_date}}</td>
                        <td style="font-size: 15px;">{{item.advt_name | slice :0:30}}</td>
                        <td style="font-size: 15px;">{{item.rep_name}}</td>
                        <td style="font-size: 15px;">{{data.off_rep_name}}</td>
                        <td style="font-size: 15px;">{{item.DS_ISSUENAME | slice :0:20}}</td>
                        <td style="font-size: 15px;">{{item.DS_ISSUEDATE}}</td>
                        <td style="font-size: 15px;">{{item.advt_invoice_no}}</td>
                        <td style="font-size: 15px;">{{item.advt_invoice_date}}</td>
                        <td style="text-align: end; font-size: 15px;">{{(item.net_amt * 1).toFixed(2)}}</td>
                        <td style="text-align: end; font-size: 15px;">{{(item.tds_amt * 1).toFixed(2)}}</td>
                        <td style="text-align: end; font-size: 15px;">{{(item.other_credit_amt * 1).toFixed(2)}}</td>
                        <td style="text-align: end; font-size: 15px;">{{(item.credit_v_amt * 1).toFixed(2)}}</td>
                        <td style="text-align: left; font-size: 15px;">{{item.credit_remark }}</td>
                    </tr>
                    
                    <!-- Representative Total -->
                    <tr style="background-color: #e3f2fd;">
                        <td style="font-weight: bold; font-size: 14px;" colspan="10">
                            Representative Total ({{rep.rep_name}}):
                        </td>
                        <td style="text-align: end; font-weight: bold; font-size: 14px;">
                            {{rep.tds_amt.toFixed(2)}}
                        </td>
                        <td style="text-align: end; font-weight: bold; font-size: 14px;">
                            {{rep.other_credit_amt.toFixed(2)}}
                        </td>
                        <td style="text-align: end; font-weight: bold; font-size: 14px;">
                            {{rep.total.toFixed(2)}}
                        </td>
                        <td></td>
                    </tr>
                </ng-container>
                
                <!-- Office Representative Total -->
                <tr style="background-color: #f8f9fa;">
                    <td style="font-weight: bold; font-size: 15px;" colspan="10">
                        Office Total ({{data.off_rep_name}}):
                    </td>
                    <td style="text-align: end; font-weight: bold; font-size: 15px;">
                        {{data.tds_amt.toFixed(2)}}
                    </td>
                    <td style="text-align: end; font-weight: bold; font-size: 15px;">
                        {{data.other_credit_amt.toFixed(2)}}
                    </td>
                    <td style="text-align: end; font-weight: bold; font-size: 15px;">
                        {{data.total.toFixed(2)}}
                    </td>
                    <td></td>
                </tr>
            </tbody>

            <!-- Grand Total -->
            <tbody>
                <tr>
                    <td style="font-weight: bold; text-align: center; background-color: #e9ecef; color: #111111; font-size: large;" colspan="10">
                        Grand Total:
                    </td>
                    <td style="text-align: end; font-weight: bold; background-color: #e9ecef; color: #111111; font-size: large;">
                        {{CreditadvtOffInDTotalTds.toFixed(2)}}
                    </td>
                    <td style="text-align: end; font-weight: bold; background-color: #e9ecef; color: #111111; font-size: large;">
                        {{CreditadvtOffInDTotalOther.toFixed(2)}}
                    </td>
                    <td style="text-align: end; font-weight: bold; background-color: #e9ecef; color: #111111; font-size: large;">
                        {{CreditadvtOffInDTotal.toFixed(2)}}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div style="margin-left: 80%; margin-bottom: 2%;">
        <button class="noPrint" style="margin-top: 2%; margin-right: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
            ExportOff
        </button>

        <button class="btn btn-primary" (click)="printPage4()">Print</button>
        
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>